export default "__VITE_ASSET__BHtM9$f7__"